import { I18n } from "i18n-js";
import en from "./en.json";
import ja from "./ja.json";

const i18n = new I18n();
// i18n.fallbacks = true;
i18n.translations = { en, ja };
i18n.defaultLocale = "en";
i18n.missingTranslation = () => null;

/**
 * Translates text.
 *
 * @param key The i18n key.
 */
export function translate(key: string, options?: object) {
  try {
    return key ? i18n.t(key, options) : null;
  } catch (err) {
    // console.log("error with translate function in translate.ts: ", err);
    return null;
  }
}
